import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoggerService } from 'src/app/service/logger.service';
import { CommPlan } from '../../models/commission/comm-plan.model';
import { CommPlanDetail } from '../../models/commission/comm-plan-detail.model';
import { Renderer2 } from '@angular/core';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { NotificationService } from 'src/app/service/notification.service';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { GlobalService } from 'src/app/service/global.service';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { CalendarModel } from 'src/app/models/config/calendar.model';
import { CommissionPlanService } from 'src/app/service/commplan.service';
import { CommissionService } from 'src/app/service/commission.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-comm-plan',
  templateUrl: './comm-plan.component.html',
  styleUrls: ['./comm-plan.component.css']
})
export class CommPlanComponent implements OnInit {
  commModel = new CommPlan();
  commData: CommPlan[] = [];
  selctedCommPlan: CommPlan[] = [];
  selctedCommPlans: CommPlan[] = [];
  replicateResponse: CommPlan = null;
  public calTypes: CalendarModel[] = [];
  chargebacktypesdata: CommPlanDetail[];
  salesChannelsData: CommPlanDetail[];
  salesChannels: string[] = [];
  editableHeader: boolean = false;
  isReplicate: boolean = true;
  isUpdate: boolean = true;
  filteredValues: CommPlan[] = [];
  selectedSc: string = 'All';
  filterScValue: string = '';
  radioCheck: boolean = false
  count: number = 0;
  flags: string[] = ['Y', 'N'];
  plans: string[] = ['Hidden Plans', 'Include Inactive Plans']
  kpiDetails: CommPlanDetail[] = [];
  favoriteSeason: string = null;
  mySalesChannelSet = new Set<string>();
  currentCheckedValue = null;
  Languages: string[] = [];
  countryOptions: { code: string, label: string }[] = [
    { code: 'US', label: 'United States' },
    { code: 'JM', label: 'Jamaica' }
  ];
  payrollCalender: string[] = [];
  permissionCheck: any;
  isAccessDisabled: boolean = false;
  isChecked: boolean = false;
  public showLoading: boolean;

  ordersTableColumns1: TableColumn[];
  columnsData: any;
  pageColumnsData: any;
  actions: any;
  checkbox: any;
  actionButtons: any;
  kpiType: string;
  clickedKpiType: string;
  edate: any;

  menusFilter: UserManagementModel[] = [];
  isView: boolean = true;

  constructor(private commissionService: CommissionService, private commissionPlanService: CommissionPlanService, 
    private logger: LoggerService, private manageUserService: ManageUserService,
    private router: Router, private notificationService: NotificationService,
    private ren: Renderer2, private globalService: GlobalService, private httpService: HttpClient) { globalService._disableBackButton(); }

  ngOnInit(): void {
    this.init();
    this.isAccessDisabled = this.globalService._permissionCheck('comm-plan');
    if (this.isAccessDisabled)
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
  }

  public init() {
    this.initializeColumns();
    this.resetData();
    this.getAllCommPlans();
    this.getCalTypes();
    this.getChargebackTypes();
    this.getSalesChannelsList();
  }

  public onSalesChannelChange(salesChannelDesc: string): void {
    if (salesChannelDesc === 'Jamaica') {
      this.commModel.country = 'JM';
    } else if (!this.commModel.country || this.commModel.country === 'JM') {
      // Leaving the Jamaica channel must reset the JM default back to US; otherwise a
      // non-Jamaica plan could be saved with country='JM'.
      this.commModel.country = 'US';
    }
  }

  public insertCommissionPlan(newForm: NgForm): void {
    if (!this.commModel.comPlan) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Enter Commission Plan");
    } else if (!this.commModel.commPlan) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Enter Commission Plan Description");
    } else if (!this.commModel.calendar_type) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Calendar Type");
    } else if (!this.commModel.effective_date) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Effective Date");
    } else if (!this.commModel.sales_channel_desc) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Sales Channel");
    } else if (!this.commModel.country) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Country");
    } else if (!this.commModel.display_flag) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Show Plan");
    } else if (!this.commModel.charge_back_type) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Chargeback Type");
    } else if (!this.commModel.charge_back) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Chargeback");
    } else {
      this.commModel.active_flag = "Y";
      this.commModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      //this.selctedCommPlan.push(this.commModel);
      console.log(this.commModel);
      this.showLoading = true;
      this.commissionPlanService.insertCommissionPlan(this.commModel).subscribe(
        (response: CommPlan) => {
          console.log(JSON.stringify(response));
          //this.commModel = null;
          newForm.reset();
          this.clickButton('closeAddButton');
          this.notificationService.sendNotification(NotificationType.SUCCESS, "Inserted Successfully");
          this.showLoading = false;

          this.commissionPlanService.clearCache();
          this.getAllCommPlans();

        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          console.log(msg);
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
          this.showLoading = false;
        }
      )
    }
  }



  public getChargebackTypes(): void {
    this.commissionService.getChargebackTypes().subscribe(
      (response: CommPlanDetail[]) => {
        this.chargebacktypesdata = response;
        //console.log(this.chargebacktypesdata);
        this.chargebacktypesdata = this.chargebacktypesdata.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  changed(values: any) {
    this.isChecked = values.value.currentTarget.checked;

    if (values.value.currentTarget.checked == true) {
      this.filterAllInActivePlans();
    } else {
      this.filterAllActivePlans();
    }
  }

  exportExcel() { }

  getCalTypes() {
    this.commissionService.getCalTypes()
      .subscribe((data: any) => {
        this.calTypes = data;
        const filterValue = this.globalService._normalizeValue('Active');
        this.calTypes = this.calTypes.filter(cal => this.globalService._normalizeValue(cal.active_flag).startsWith(filterValue));
        //this.measureagainstdata = this.measureagainstdata.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  newReplicatePlan(Comm: CommPlan, values: any, URL: string) {
    console.log("Inside newReplicatePlan()");
    Comm.created_by =localStorage.getItem('CURRENT_USER_NAME_SESSION');
    //console.log("selectedComm comm = " + JSON.stringify(Comm));
    this.edate = Comm.effective_date;
    Comm.status = "replicate";
    this.commissionService.replicateCommPlan(Comm)
      .subscribe(response => {
        this.replicateResponse = JSON.parse(JSON.stringify(response));
        console.log(this.replicateResponse);
        this.replicateResponse.status = "getreplicate";

        this.notificationService.sendNotification(NotificationType.SUCCESS, `Commission Plan Replicated Successfully`);
        this.selectedComm(this.replicateResponse, true, 'edit-kpi', 'stat1');

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public selectedComm(Comm: CommPlan, values: any, URL: string, stat: string) {
    console.log("Inside selectedComm()");
    if (values === true) {
      this.selctedCommPlan.push(Comm);
      Comm.editMode = true;
      this.editableHeader = true;
    } else {
      this.selctedCommPlan.forEach((value: any, index: any) => {
        if (value.commPlan == Comm.commPlan) this.selctedCommPlan.splice(index, 1);
      });
      Comm.editMode = false;
      if (!this.isAccessDisabled)
        this.isReplicate = false;
    }
    if (this.selctedCommPlan.length == 0) {
      this.editableHeader = false;
      this.isUpdate = true;
    }
    if (this.selctedCommPlan.length > 1 || this.selctedCommPlan.length == 0) {
      this.isReplicate = true;
      this.isView = true;
    } else if (this.selctedCommPlan.length == 1) {
      this.commModel = this.selctedCommPlan[0];

      this.commissionService.getKpiDetailsForPlan(this.commModel.commPlanId, this.commModel.effective_date)
        .subscribe((data: CommPlanDetail[]) => {
          //console.log(JSON.stringify(data));
          this.commissionService.kpiDetails = data;
         // console.log(this.commissionService.kpiDetails);
          this.isView = false;
          if (!this.isAccessDisabled)
            this.isReplicate = false;

          this.replicatePlan(URL, stat);
          //this.logger.info('getKpiDetailsForPlan :', data);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    }
    if (this.selctedCommPlan.length > 0 && !this.isAccessDisabled) {
      this.isUpdate = false;
    }

  }

  public replicatePlan(url: string, stat: string) {
    console.log("Inside replicatePlan()");
    console.log(url);

     localStorage.setItem("commModel",JSON.stringify(this.commModel));
    // localStorage.setItem("channels",JSON.stringify(this.salesChannels));

    this.commModel.pageviewstatus = stat;
    this.commissionService.commModel = this.commModel;
    this.commissionService.salesChannels = this.salesChannels;
    this.router.navigate(['/' + url]);
  }

  public updateCommPlan() {
    this.selctedCommPlan = [];
    for (let updatePlan of this.filteredValues) {
      if (updatePlan.editMode) {
        updatePlan.update_dt
        updatePlan.update_dt = new Date();
        updatePlan.updated_by =localStorage.getItem('CURRENT_USER_NAME_SESSION');
        this.selctedCommPlan.push(updatePlan);
      }

    }
    console.log(this.selctedCommPlan);
    this.commissionPlanService.updateCommPlan(this.selctedCommPlan)
      .subscribe(response => {
        // response = response as ErrorResponseMessage;
        console.log(' relicate resp=== ', response);
       
        this.reloadPage();


      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }




  public resetData() {
    this.commModel = new CommPlan();
    this.commData = [];
    this.selctedCommPlan = [];
    this.salesChannels = [];
    this.editableHeader = false;
    this.isReplicate = true;
    this.isUpdate = true;
    this.filteredValues = [];
    this.selectedSc = 'All';
    this.filterScValue = '';
    this.radioCheck = false
    this.count = 0;
    this.flags = ['Y', 'N'];
    this.plans = ['Hidden Plans', 'Include Inactive Plans']
    this.kpiDetails = [];
    this.favoriteSeason = null;
    this.mySalesChannelSet = new Set<string>();
    this.currentCheckedValue = null;
    this.Languages = [];
    this.payrollCalender = [];
  }

  public getSalesChannelsList(): void {
    this.commissionService.getSalesChannelsList().subscribe(
      (response: CommPlanDetail[]) => {
        this.salesChannelsData = response;
        //console.log(this.salesChannelsData);
        //this.salesChannelsData = this.salesChannelsData.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  getAllCommPlans() {
    this.commissionService.getAllCommPlansByDate()
      .subscribe((data: CommPlan[]) => {
        //console.log('getAllCommPlans :', JSON.stringify(data));
       // console.log("getAllCommPlans() TS file");
        this.commData = data;
        this.filterAllActivePlans();
        this.getSalesChannels();
        this.commissionService.commData = this.commData;

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  filterAllActivePlans() {
    const filterValue = this._normalizeValue('Y');
    this.filteredValues = this.commData.filter(comm => this._normalizeValue(comm.active_flag).includes(filterValue));
    //console.log("this.filteredValues = "+JSON.stringify(this.filteredValues));
  }

  filterAllInActivePlans() {
    this.filteredValues = this.commData;
    //console.log("this.filteredValues = "+this.filteredValues);
  }

  getSalesChannels() {
    for (let comm of this.commData) {
      if (comm.sales_channel_desc) {
        this.salesChannels.push(comm.sales_channel_desc);
        this.mySalesChannelSet.add(comm.sales_channel_desc);
      }
      if (!comm.calendar_type) {
        comm.calendar_type = 'CORPORATE_MONTHLY';
      }
    }
    this.salesChannels = this.salesChannels.sort((a, b) => (a < b) ? -1 : 1);
    this.salesChannels = this.salesChannels.filter((v, i) => this.salesChannels.findIndex(item => item == v) === i);
    this.getLanguages();
    // console.log('sales chnl== ', this.mySalesChannelSet);
  }

  getLanguages() {
   // console.log("Inside getLanguages()");
    this.manageUserService.getPrePopulatedUserData().subscribe((data: any) => {
      //console.log(data);
      for (let user of data) {

        if (user.language != null) {
          this.Languages.push(user.language);
          if (this.Languages.length > 1) {
            this.Languages.sort((a, b) =>
              a.localeCompare(b));
          }
        } else if (user.calendar_type != null) {
          this.payrollCalender.push(user.calendar_type);
          if (this.payrollCalender.length > 1) {
            this.payrollCalender.sort((a, b) =>
              a.localeCompare(b));
          }
        }
      }
     // console.log(this.Languages);
      this.commissionService.languages = this.Languages;
      this.commissionService.payrollCalender = this.payrollCalender;
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  public filterBySaleschannel(event: any) {
    this.favoriteSeason = null;
    this.selectedSc = event.target.value;
    this.filterScValue = this._normalizeValue(event.target.value);
    this.getBySaleschannel()
  }

  private getBySaleschannel() {
    if (this.selectedSc === 'All') {
      this.filterAllActivePlans();
    }
    else {
      this.filteredValues = this.commData.filter(comm => this._normalizeValue(comm.sales_channel_desc).includes(this.filterScValue) &&
        this._normalizeValue(comm.active_flag).includes(this._normalizeValue('Y')));
      //console.log(this.filteredValues);
    }
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }


  public handlePlan(event: any) {
    console.log(' hide plan ', event.value);

    setTimeout(() => {
      if (this.currentCheckedValue && this.currentCheckedValue === event.value) {
        event.checked = false;
        this.ren.removeClass(event['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(event['_elementRef'].nativeElement, 'cdk-program-focused');
        this.currentCheckedValue = null;
        console.log('event ', event);
        this.getBySaleschannel();
      }
      else {
        this.currentCheckedValue = event.value
        this.filterbyCode(event.value);
      }
    })
  }

  public filterbyCode(value: string) {
    const filterValue1 = this._normalizeValue(this.selectedSc);
    const filterValue = this._normalizeValue('N');
    if (value === 'Include Inactive Plans') {

      if (this.selectedSc === 'All') {
        this.filteredValues = this.commData;
        //.filter(comm => this._normalizeValue(comm.active_flag).includes(filterValue));
      }
      else {
        this.filteredValues = this.commData.filter(comm => this._normalizeValue(comm.sales_channel_desc).includes(filterValue1));
        //&& this._normalizeValue(comm.active_flag).includes(filterValue));
      }
      //console.log(this.filteredValues);
    }

    if (value === 'Hidden Plans') {

      if (this.selectedSc === 'All') {
        this.filteredValues = this.commData.filter(comm => this._normalizeValue(comm.display_flag).includes(filterValue));
      }
      else {
        this.filteredValues = this.commData.filter(comm => this._normalizeValue(comm.sales_channel_desc).includes(filterValue1)
          && this._normalizeValue(comm.display_flag).includes(filterValue));
      }
      //console.log(this.filteredValues);
    }
  }

  reloadPage() {
    this.init();
    //window.location.reload();
  }

  update(user: any, values: any) {
    console.log("update called");
    if (values.value.currentTarget.checked) {
      this.selctedCommPlans.push(user.row);
    } else {
      this.selctedCommPlans.forEach((value: any, index: any) => {
        if (value.comm_plan_id == user.row.comm_plan_id) this.selctedCommPlans.splice(index, 1);
      });
    }
    // console.log("this.selctedCommPlans = " + JSON.stringify(this.selctedCommPlans));
  }

  public updateCommPlanStatusToActive() {
    this.commissionService.updateCommPlanStatusToActive(this.selctedCommPlans)
      .subscribe(response => {
        this.commissionPlanService.clearCache();
        this.getAllCommPlans();
        this.selctedCommPlans = [];
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  public updateCommPlanStatusToInactive() {
    this.commissionService.updateCommPlanStatusToInactive(this.selctedCommPlans)
      .subscribe(response => {
        this.commissionPlanService.clearCache();
        this.getAllCommPlans();
        this.selctedCommPlans = [];
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }



  private 
  clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  public clickToCloseButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  innerRowAction1(row: any) {
    if (row.value === 'View') {
      //console.log(row.row);
      //this.selectedComm(row.row, true, 'view-plan', 'stat0');
      this.selectedComm(row.row, true, 'edit-kpi', 'View');
    }
    if (row.value === 'Replicate') {
      //console.log("Replicate: " + row.row);
      this.selectedComm(row.row, true, 'replicate-plan', 'Replicate');
    }

    if (row.value === 'Update') {
      this.selectedComm(row.row, true, 'edit-kpi', 'Update');
    }

  }



  actionOnButton(action: any) {
    if (action === "Active") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.updateCommPlanStatusToActive();
      }
    } else if (action === "Inactive") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.updateCommPlanStatusToInactive();
      }
    } else if (action === "Add") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.clickButton(action);
      }
    }
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns1 = this.columnsData.commissionPlan;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });

    this.actions = [
      {
        name: 'View',
        dataKey: 'far fa-eye success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Replicate',
        dataKey: 'fas fa-clone success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Update',
        dataKey: 'fas fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      }
    ]

    this.actionButtons = [
      {
        name: 'Add',
        class: 'btn btn-primary btn-xs'
      },
      {
        name: 'Active',
        class: 'btn btn-success btn-xs'
      },
      {
        name: 'Inactive',
        class: 'btn btn-danger btn-xs'
      }
    ]

  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  isLastDayOfMonth(date: Date | null): boolean {
    date = date ?? new Date();
    const dayOfMonth = date.getDate();
    const lastDayOfMonth = getLastDayOfMonth(date);

    return dayOfMonth === lastDayOfMonth;
  };

}

function getLastDayOfMonth(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), 1).getDate();
}
